
const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-gradient-to-r from-pink-500 to-purple-500 text-white py-8 px-6">
        <div className="text-center">
          <h1 className="text-2xl font-bold">個人情報の取り扱いについて</h1>
        </div>
      </header>

      {/* Content */}
      <div className="px-6 py-12 max-w-4xl mx-auto">
        <div className="space-y-8">
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-4">1. 個人情報の収集について</h2>
            <p className="text-gray-600 leading-relaxed">
              湯沢開発株式会社（以下「当社」）では、お客様からお問い合わせやモデルハウス見学予約をいただく際に、
              お名前、電話番号、メールアドレス、ご質問内容等の個人情報を収集させていただきます。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-4">2. 個人情報の利用目的</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              収集した個人情報は、以下の目的で利用いたします：
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
              <li>お問い合わせへの回答</li>
              <li>モデルハウス見学のご案内</li>
              <li>商品・サービスに関する情報提供</li>
              <li>アフターサービスのご提供</li>
              <li>その他、お客様との連絡に必要な業務</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-4">3. 個人情報の第三者提供</h2>
            <p className="text-gray-600 leading-relaxed">
              当社は、法令に基づく場合を除き、お客様の同意なく個人情報を第三者に提供することはありません。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-4">4. 個人情報の管理</h2>
            <p className="text-gray-600 leading-relaxed">
              当社は、個人情報の漏洩、滅失、毀損の防止その他個人情報の安全管理のために必要かつ適切な措置を講じます。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-4">5. 個人情報の開示・訂正・削除</h2>
            <p className="text-gray-600 leading-relaxed">
              お客様ご本人から個人情報の開示、訂正、削除等のお申し出があった場合には、
              ご本人であることを確認の上、合理的な期間内に対応いたします。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-4">6. お問い合わせ窓口</h2>
            <div className="bg-gray-50 rounded-lg p-6">
              <p className="text-gray-600 mb-4">
                個人情報の取り扱いに関するお問い合わせは、下記までご連絡ください：
              </p>
              <div className="space-y-2 text-gray-700">
                <p><strong>湯沢開発株式会社</strong></p>
                <p>〒012-0844 秋田県湯沢市田町2丁目1番3号</p>
                <p>電話：0183-73-7125</p>
                <p>営業時間：8:45～17:00（水曜日定休）</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-4">7. プライバシーポリシーの変更</h2>
            <p className="text-gray-600 leading-relaxed">
              当社は、法令の変更等に伴い、本プライバシーポリシーを変更することがあります。
              変更後のプライバシーポリシーは、当ウェブサイトに掲載した時点から効力を生じるものとします。
            </p>
          </section>

          <div className="text-right text-gray-500 text-sm mt-12">
            <p>制定日：2025年1月1日</p>
          </div>
        </div>

        {/* Back Button */}
        <div className="text-center mt-12">
          <button
            onClick={() => window.history.back()}
            className="bg-gradient-to-r from-pink-500 to-purple-500 text-white py-3 px-8 rounded-full font-semibold shadow-lg hover:shadow-xl transition-shadow"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
